import { ref, watchEffect } from 'vue'

const STORAGE_KEY = 'bm-theme'

// Estado global compartido entre todas las instancias del composable
const isDark = ref(localStorage.getItem(STORAGE_KEY) === 'dark')

function applyTheme(dark) {
  document.documentElement.classList.toggle('dark', dark)
}

// Aplicar al cargar
applyTheme(isDark.value)

export function useTheme() {
  watchEffect(() => {
    applyTheme(isDark.value)
    localStorage.setItem(STORAGE_KEY, isDark.value ? 'dark' : 'light')
  })

  function toggle() {
    isDark.value = !isDark.value
  }

  function setDark(value) {
    isDark.value = value
  }

  return { isDark, toggle, setDark }
}
